module.exports = __webpack_public_path__ + "img/hiw-landlord.8e05b48c.jpg";